import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import {
  ContentTooltiptStudentDistribution2,
  useStyles
} from '../../../../Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip';
import { useGroupStudentsContext } from '../GroupStudentsContext/GroupStudentsContext';
import LcElemensRow from './LcElemensRow';
import CurriculumElementsRows from './CurriculumElementsRows';
import { TableContainer } from '@mui/material';

const StudentDistributionTable = ({ onClickStudent, levelsData = [], lcs = [], onStudentView }) => {
  const classes = useStyles();
  const { currentCurriculum } = useGroupStudentsContext();
  const levels = levelsData?.sort((a, b) => b.position - a.position) || [];

  return (
    <TableContainer className='absolute inset-0'>
      <Table style={{ width: 200 }}>
        <TableBody>
          {levels?.map((lvl, index) => {
            return (
              <TableRow key={`lvl-${lvl._id}-index-${index}`}>
                <TableCell
                  className={[
                    'sticky left-0px z-10',
                    index % 2 === 0 ? ' bg-background' : ' bg-background-foreground '
                  ].join(' ')}
                >
                  <Typography className='text-muted-foreground text-center'>{lvl.name}</Typography>
                </TableCell>
                {lcs.map((lc, index) => {
                  const level = lc.levels?.find((l) => l._id === lvl._id);
                  if (!level) {
                    return (
                      <TableCell
                        width={200}
                        key={`lc-${lc.lcId}-ul-${lc.ulId}-${lc.classId}-index-${index}`}
                        className='text-center'
                      >
                        <Skeleton variant='text' width={80} />
                      </TableCell>
                    );
                  }
                  return (
                    <TableCell
                      width={200}
                      key={`lc-${lc.lcId}-ul-${lc.ulId}-${lc.classId}-index-${index}`}
                      className='text-center border-l border-muted'
                      style={{ padding: '0 0.25rem'}}
                    >
                      <div className='flex items-center justify-center py-1'>
                        {level.definition ? (
                          level.marking.map((mark, im) => {
                            const val = parseFloat(mark.value).toFixed(2);
                            return (
                              <Tooltip
                                id={`marking-${level._id}-index-${index}-marking-${mark._id}-index-${im}`}
                                key={`marking-${level._id}-index-${index}-marking-${mark._id}-index-${im}`}
                                classes={{ tooltip: classes.customWidthStudentDistribution }}
                                title={
                                  <ContentTooltiptStudentDistribution2
                                    percentage={`${val}%`}
                                    level={level}
                                    marking={{
                                      markingName: mark.name,
                                      markingPrimaryColor: mark.primaryColor,
                                      markingSecondaryColor: mark.secondaryColor
                                    }}
                                    onClick={onStudentView}
                                    students={mark.students.length || 0}
                                    totalStudents={lc.totalStudents}
                                  />
                                }
                                arrow
                              >
                                <div
                                  className='hover-outline-muted text-xs flex flex-col items-center justify-center w-full bg-loading2 cursor-pointer overflow-hidden outline-background cursor-pointer'
                                  style={{
                                    height: 40,
                                    width: `${val}%`,
                                    backgroundColor: mark.primaryColor,
                                    color: mark.secondaryColor
                                  }}
                                  onClick={() => onClickStudent({
                                    levelName: level.name,
                                    levelDefinition: level.definition,
                                    markingName: mark.name,
                                    markingPrimaryColor: mark.primaryColor,
                                    markingSecondaryColor: mark.secondaryColor,
                                    students: mark.students || [],
                                    percentage: mark.value,
                                    lcId: lc.lcId,
                                    _id: `${lc.lcId}-${level._id}-${mark._id}`,
                                    lcs: [lc]
                                  })}
                                >
                                  {parseFloat(mark.value).toFixed(0)}%
                                </div>
                              </Tooltip>
                            );
                          })
                        ) : (
                          <div
                            className=' text-xs flex flex-col items-center justify-center w-full  bg-lines'
                            style={{
                              height: 40,
                              width: `100%`
                            }}
                          />
                        )}

                        {/* {level.marking.map((mark, im) => {
                          const val = parseFloat(mark.value).toFixed(2);
                          return (
                            <Tooltip
                              id={`marking-${level._id}-index-${index}-marking-${mark._id}-index-${im}`}
                              key={`marking-${level._id}-index-${index}-marking-${mark._id}-index-${im}`}
                              classes={{ tooltip: classes.customWidthStudentDistribution }}
                              title={
                                <ContentTooltiptStudentDistribution2
                                  percentage={`${val}%`}
                                  level={level}
                                  marking={{
                                    markingName: mark.name,
                                    markingPrimaryColor: mark.primaryColor,
                                    markingSecondaryColor: mark.secondaryColor
                                  }}
                                  onClick={onStudentView}
                                  students={mark.students.length || 0}
                                  totalStudents={students}
                                />
                              }
                              arrow
                            >
                              <div
                                className='hover-outline-muted text-xs flex flex-col items-center justify-center w-full bg-loading2 cursor-pointer overflow-hidden outline-background cursor-pointer'
                                style={{
                                  height: 40,
                                  width: `${val}%`,
                                  backgroundColor: mark.primaryColor,
                                  color: mark.secondaryColor
                                }}
                              >
                                {parseFloat(mark.value).toFixed(0)}%
                              </div>
                            </Tooltip>
                          );
                        })} */}
                      </div>
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
          <LcElemensRow
            currentCurriculum={currentCurriculum}
            lcs={lcs}
            width='min-w-120px max-w-120px '
          />
          <CurriculumElementsRows
            lcs={lcs}
            width='min-w-120px max-w-120px'
            currentCurriculum={currentCurriculum}
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentDistributionTable;
